<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="versions"
      :pagination.sync="defaultSort"
      expand
      item-key="id"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
          <td style="width: 10px;">
            <v-icon v-if="props.expanded">expand_more</v-icon>
            <v-icon v-else>expand_less</v-icon>
          </td>
          <td>
            {{ props.item.date | moment("MMMM DD YYYY, h:mma") }}
          </td>
          <td>
            {{ props.item.event }}
          </td>
          <td>
            {{ props.item.whodunnit }}
          </td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat color="grey lighten-4" class="py-0 px-2">
          <v-card-text class="py-0 pb-2">
            <v-data-table
              :headers="innerHeaders"
              :items="props.item.changes"
              :pagination.sync="innerDefaultSort"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td>
                    {{ props.item.changed }}
                  </td>
                  <td>
                    {{ props.item.from }}
                  </td>
                  <td>
                    {{ props.item.to }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: [
    'versions'
  ],
  components: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  created () {
    this.setUp()
  },
  watch: {
  },
  data: function () {
    return {
      expand: false,
      defaultSort: {
        sortBy: 'date',
        descending: true,
        rowsPerPage: 25,
      },
      innerDefaultSort: {
        sortBy: 'changed',
        ascending: true,
        rowsPerPage: -1,
      },
      innerHeaders: [
        {
          text: 'Field Changed',
          value: 'changed',
          sortable: false,
        },
        {
          text: 'Previous Value',
          value: 'from',
          sortable: false,
        },
        {
          text: 'New Value',
          value: 'to',
          sortable: false,
        },
      ],
      headers: [
        {
        },
        {
          text: "Change date",
          value: 'date',
        },
        {
          text: "Change type",
          value: 'event',
        },
        {
          text: "User responsible",
          value: 'whodunnit'
        },
      ],
    }
  },
  methods: {
    setUp () {
    },
  },
}
</script>

<style scoped>
</style>
